export default "__VITE_ASSET__uL1V5iXi__"